import { ConfigTab } from './config.state';

export class SetActiveConfigTab {
  static readonly type = '[ConfigState] SetActiveConfigTab';
  constructor(public readonly tab: ConfigTab) {}
}
